export default __webpack_public_path__ + "2b559445bc610ca944c394d0487ccc23.eot";